import React from 'react';
import Layout from './Layout';
import { TableContext } from '../../contexts/TableContext';
import { TableContextProvider } from '../../interfaces/common';

interface TableBoxProps {
  tableValues: TableContextProvider;
}

const TableBox: React.FC<TableBoxProps> = ({ tableValues }) => {
  return (
    <TableContext.Provider value={tableValues}>
      <Layout />
    </TableContext.Provider>
  );
};

export default TableBox;
